import { TextDisclosure } from '@cxc/react-fpds-components';
import styles from './Disclosure.module.scss';
import React from 'react';

const Disclosure: React.FC = () => {
    const disclosureItems = [
        {
            text: 'All incentives are from a third party source and do not include any manufacturer or dealer incentives, if applicable.',
            onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' }),
        },
    ];
    return (
        <div id="disclosure-1">
            <TextDisclosure
                titleProp={{
                    title: '',
                    headingLevel: 'h6',
                }}
                className={styles.disclosure}
                disclosureItems={disclosureItems}
                returnToLinkTitle="Return to content"
            />
        </div>
    );
};

export default Disclosure;
